export const assetData = [
  {
    "Asset ID": "ASD-GSE-01CR01-PAC002",
    id: "69b8a511-b5ff-41c0-b24c-d8d491407f18",
    "Forecasted Replacement Date": "2028",
    "Asset Name": "AIR COMPRESSOR",
    Level: "5",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    location: "1",
    Recommendation: "Do Nothing",
    maintenance: "$12,199",
    forecast: "$0",
    saving: "$12,199",
    "Score A": "12",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    "Forecasted Replacement Date": "2026",
    id: "0f905d32-734c-4291-933c-7b8dcf0488aa",
    "Asset Name": "AIR COMPRESSOR",
    Level: "5",
    maintenance: "$45,563",
    saving: "$45,563",
    forecast: "$0",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    Recommendation: "Do Nothing",
    location: "1",
    "Score A": "14",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    id: "6cd49beb-cb2b-4c5f-88d7-4fe4d2a1ed0b",
    "Forecasted Replacement Date": "2029",
    "Asset Name": "AIR COMPRESSOR",
    maintenance: "$1,760",
    saving: "$1,760",
    forecast: "$0",
    Level: "5",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    Recommendation: "Do Nothing",
    location: "1",
    "Score A": "12",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
];
